import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";

const CarouselSlider = () => {
  const images = [
    {
      id: 1,
      src: "https://i.postimg.cc/sXLQ0Y38/aba67836aa0b97d1b12afb3aac664197.png",
      alt: "AMIR Logo",
    },
    {
      id: 2,
      src: "https://i.postimg.cc/XYnf5gqc/caeb92c0914977a0eb18fabddb465b68.png",
      alt: "Son-x Logo",
    },
    {
      id: 3,
      src: "https://i.postimg.cc/sXLQ0Y38/aba67836aa0b97d1b12afb3aac664197.png",
      alt: "AMIR Logo",
    },
    {
      id: 4,
      src: "https://i.postimg.cc/XYnf5gqc/caeb92c0914977a0eb18fabddb465b68.png",
      alt: "Son-x Logo",
    },
    
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  // Automatically change slides every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000); // 3000ms = 3 seconds

    return () => clearInterval(interval); // Clear the interval on component unmount
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "300px",
        overflow: "hidden",
        padding: "2rem",
      }}
    >
      {/* Left Arrow */}
      <Box
        onClick={handlePrev}
        sx={{
          position: "absolute",
          left: "10px",
          fontSize: "2rem",
          cursor: "pointer",
          color: "green",
          zIndex: 10,
        }}
      >
        &lt;
      </Box>

      {/* Image Container */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "100%",
          position: "relative",
        }}
      >
        {images.map((image, index) => {
          const position =
            index === currentIndex
              ? 0
              : index === (currentIndex - 1 + images.length) % images.length
              ? -100
              : index === (currentIndex + 1) % images.length
              ? 100
              : 1000; // Push other images off-screen

          // Apply a box highlight to the centered image
          const highlightStyle =
            index === currentIndex
              ? {
                  border: "4px solid #A9C47F", // Highlight with a green box
                  boxShadow: "0px 0px 15px rgba(0, 128, 0, 0.5)",
                }
              : {};

          return (
            <Box
              key={image.id}
              sx={{
                position: "absolute",
                transform: `translateX(${position}%)`,
                transition: "transform 0.5s ease-in-out",
                opacity: Math.abs(position) === 1000 ? 0 : 1,
                width: "300px",
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  width: "200px",
                  height: "200px",
                  borderRadius: "16px",
                  border: "2px solid #A9C47F",
                  backgroundColor: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  ...highlightStyle, // Apply highlight style if it's the current image
                }}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    padding: "10px",
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* Right Arrow */}
      <Box
        onClick={handleNext}
        sx={{
          position: "absolute",
          right: "10px",
          fontSize: "2rem",
          cursor: "pointer",
          color: "green",
          zIndex: 10,
        }}
      >
        &gt;
      </Box>
    </Box>
  );
};

export default CarouselSlider;
